import React from 'react';
import "./styles.css";

function About() {
    return (
        <div className="about-container">
            <h1 className="container-title">What is Project Sign?</h1>
            <p>Project Sign is an interactive web application that aims to teach users American Sign Language (ASL) through the use of a chatbot and keyboard. The chatbot is designed to help users learn the basics of ASL, while the keyboard allows users to practice signing individual letters.</p>
        </div>
    );
}

export default About;